"use client";
import React, { useEffect } from "react";
import "../styles/Project.css";

import Beams from "./Beams";
import Header from "./Header";
import Footer from "./Footer";

import maintenanceImage from "../assets/project4A.jpg";
import maintenanceVideo from "../assets/projectvid1.mp4";

import sectionImg from "../assets/project7A.png";
import leftBlockImg from "../assets/project2A.jpg";
import rightBlockImg from "../assets/project3A.jpg";

import AOS from "aos";
import "aos/dist/aos.css";

const Project = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      {/* ================= Top Section ================= */}
      <div className="project-services-container">
        <div className="project-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        <div className="project-services-left" data-aos="fade-right">
          <h1>Our Projects</h1>
          <p>
            Our extensive portfolio showcases our capability to handle projects
            of all sizes and complexities across various sectors, including:
            <br />• Infrastructure
            <br />• Oil & Gas
            <br />• Renewable Energy
            <br />• Industrial Facilities
            <br />
            Partner with us for your next project and experience the difference
            of working with industry leaders committed to your success.
          </p>
        </div>

        <div className="project-services-right" data-aos="fade-left">
          <img
            src={maintenanceImage}
            alt="Maintenance"
            className="project-gif"
          />
        </div>
      </div>

     

      {/* ================= Middle Section ================= */}
      <div className="project-middle-section">
        <div className="project-middle-left" data-aos="fade-right">
          <img src={sectionImg} alt="Project Overview" />
        </div>
      </div>
 {/* ================= Full Width Video ================= */}
      <div className="project-video-section" data-aos="fade-up">
        <video
          className="project-full-video"
          src={maintenanceVideo}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>
      {/* ================= Bottom Section ================= */}
      <div className="project-bottom-section">
        <div className="project-bottom-box" data-aos="fade-up-right">
          <h3>DEWA</h3>
          <img src={leftBlockImg} alt="Project 1" />
          <p>132/11kv substation and associated works</p>
        </div>

        <div className="project-bottom-box" data-aos="fade-up-left">
          <h3>DEWA</h3>
          <img src={rightBlockImg} alt="Project 2" />
          <p>132/33kv substation cable diversion works</p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Project;
